import qs from 'qs'
import axios from 'axios'

class Request {
  constructor(options) {
    this.config = options
    this.instance = axios.create(options)
    this.setupInterceptor()
  }

  setupInterceptor() {
    // 请求拦截
    this.instance.interceptors.request.use(
      config => {
        // if (process.env.NODE_ENV === 'production') {
        //   if (config.url.match(/^\/cms/)) {
        //     config.baseURL = process.env.VUE_APP_CMS_URL
        //   }
        //   if (config.url.match(/^\/analyzer/)) {
        //     config.baseURL = process.env.VUE_APP_ANALYZER_URL
        //   }
        // }

        const userData = sessionStorage.getItem('userData')
        const { token } = userData ? JSON.parse(userData) : {}

        if (token) {
          config.headers['Ac-Token'] = token
        } else {
          if (!config.url.includes('login')) {
            window.location.href = '/login'
          }
        }

        return config
      },
      error => {
        return Promise.reject(error)
      },
    )

    // 响应拦截
    this.instance.interceptors.response.use(
      async res => {
        const contentDisposition = res.headers['content-disposition']
        const isAttachment = contentDisposition?.includes('attachment')

        // 针对 responseType: 'blob' 的特殊处理
        if (res.config.responseType === 'blob') {
          const contentType = res.headers['content-type']

          if (
            contentType?.includes('application/json') ||
            contentType?.includes('text/xml') ||
            contentType?.includes('text/html')
          ) {
            // ⚠️ 出错了，Blob 是错误页面或错误信息，需要解析文本内容
            const text = await res.data.text()
            console.error('下载接口返回错误：', text)
            return Promise.reject(new Error('下载失败：服务器返回错误信息'))
          }

          // 返回真正的文件流
          console.log('文件流', res)
          return res
        }

        // 正常 JSON 响应
        const { code, message } = res.data
        switch (code) {
          case 200:
            return Promise.resolve(res.data.data)
          case 1150:
            window.location.href = '/login'
            return Promise.reject(res.data)
          default:
            message && console.error(message)
            return Promise.reject(res.data)
        }
      },
      error => {
        if (axios.isCancel(error)) return
        console.error('请求异常：', error)
        return Promise.reject(error)
      },
    )
  }

  request(config) {
    return new Promise((resolve, reject) => {
      this.instance
        .request(config)
        .then(res => {
          console.log('请求成功', res)
          if (res.headers && res.headers['content-disposition']?.includes('attachment')) {
            return resolve(res)
          }

          resolve(res)
        })
        .catch(err => {
          console.error('请求失败', err)
          reject(err)
        })
    })
  }

  get(config) {
    return this.request({
      ...config,
      method: 'GET',
    })
  }

  post(config) {
    return this.request({
      ...config,
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: qs.stringify(config.data, {
        arrayFormat: 'repeat',
      }),
      method: 'POST',
    })
  }

  postJson(config) {
    return this.request({
      ...config,
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json;charset:utf-8',
      },
      data: config.data,
      method: 'POST',
    })
  }

  postFile(config) {
    return this.request({
      ...config,
      headers: {
        Accept: '*/*',
        'Content-Type': 'multipart/form-data',
      },
      data: config.data,
      method: 'POST',
      responseType: 'json',
    })
  }

  delete(config) {
    return this.request({
      ...config,
      method: 'DELETE',
    })
  }

  patch(config) {
    return this.request({
      ...config,
      method: 'PATCH',
    })
  }

  // download(config) {
  //   return this.request({
  //     ...config,
  //     method: 'POST',
  //     responseType: 'blob',
  //     headers: {
  //       Accept: '*/*',
  //       'Content-Type': 'application/json',
  //     },
  //     data: config.data,
  //   })
  // }

  download(config, customFileName = '定制列表.xlsx') {
    return this.request({
      ...config,
      method: 'POST',
      responseType: 'blob',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
      },
      data: config.data,
    }).then(res => {
      const blob = new Blob([res.data], { type: res.headers['content-type'] })

      let fileName = customFileName
      const disposition = res.headers['content-disposition']

      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/)
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1])

          // 🚫 如果后缀是错误的，强制替换成 .xlsx
          fileName = fileName.replace(/\.\w+$/, '') + '.xlsx'
        }
      }

      const a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      a.download = fileName
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      URL.revokeObjectURL(a.href)
      document.body.removeChild(a)

      return Promise.resolve()
    })
  }
}

let hostURL = 'https://api.gd-caxin.com'
// hostURL = 'http://47.100.81.66:45894'

const Http = new Request({
  baseURL: hostURL,
  withCredentials: true,
  timeout: 6000000,
})

export default Http
